import assign from 'object-assign';
import mergeDeep from "../../../util/mergeDeep";

import toelatingenApi from "../../../api/e-loket/toelatingenApi";
import * as messages from "../../../constants/ToastrConstants";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";
import FilesHelper from "../../common/FilesHelper";
import { showToastrError, showToastrWarning, showToastrSuccess } from "../../../util/toastr";
import { formatFilesForSave } from "../../../components/common/FilesHelperUtil";

export default class ToelatingPerGemeentePageHelper {
	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;

		const tochtId = params.tochtId;

		ajaxActions.started();
		toelatingenApi.getForGemeenteByTochtId(tochtId)
			.then((response) => {
				ajaxActions.ended();
				this.processModel(response, tochtId);
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	processModel(response, tochtId) {
		const context = this.context;
		let model = response.data;

		context.filesHelper = new FilesHelper(context, tochtId);

		model.toelating.toelatingOK = model.toelating.toelatingOK === null ? "" : model.toelating.toelatingOK;

		context.setState({
			model
		});

		context.props.loadLayout(`${model.toelating.gemeenteNaam}`);
	}

	change(event) {
		const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
		const property = event.target.name.startsWith("toelatingOK") ? "toelatingOK" : event.target.name;

		let model = mergeDeep({}, this.context.state.model);
		model.toelating[property] = value;

		this.context.setState({
			model: model,
			hasUnsavedChanges: true
		});
	}

	annuleer() {
		this.redirector.goTo("/e-loket/gemeente/veldtoertochten");
	}

	save() {
		const context = this.context;
		let state = context.state;
		const ajaxActions = context.props.ajaxActions;

		let errors = null;
		let model = null;

		let modelToSave = this.context.state.model;

		let fileBaseUrl = this.context.filesHelper.getBaseFileLocation();
		let documentsForSave = formatFilesForSave(context.state.fileComponents, fileBaseUrl);

		ajaxActions.started();
		return toelatingenApi.savePerGemeente(modelToSave, documentsForSave).then((response) => {
			ajaxActions.ended();
			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS_SAVED);
				}
				else {
					context.filesHelper.commitSession(); // Save files pas nadat validatie is geslaagd
					model = assign({}, response.data.item, {});
					errors = {};
				}
				context.setState({
					hasUnsavedChanges: false
				});

				showToastrSuccess(messages.MESSAGE_SAVED);

				this.redirector.goTo("/e-loket/gemeente/veldtoertochten");
			} else {
				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
			}

			model.toelating.toelatingOK = model.toelating.toelatingOK === null ? "" : model.toelating.toelatingOK;

			this.context.setState({
				errors,
				validationMessageType: response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
				model,
				shouldScrollToFirstError: true
			});
		})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	getErrorForProperty(propertyName) {
		const errors = this.context.state.errors;
		return errors ? errors[propertyName] : "";
	}
}
